export default __webpack_public_path__ + "static/media/cat.5aa84ae0.png";